var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"loading-ip-login",attrs:{"aria-busy":"true"}},[_c('div',{attrs:{"role":"status","aria-live":"polite","aria-atomic":"true","aria-label":"Loading through your institution"}},[_c('mcr-loading-indicator',{attrs:{"loading":true,"message":"Loading through your institution..."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }